import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import jsPDF from 'jspdf';
import { Invoice } from 'src/app/apis/invoice.service';
import * as htmlToImage from 'html-to-image';
import { AppCore } from 'src/app/utils/classes/app-core';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-print-invoice-detail-en',
  templateUrl: './print-invoice-detail-en.component.html',
  styleUrls: ['./print-invoice-detail-en.component.scss']
})
export class PrintInvoiceDetailEnComponent extends AppCore implements OnInit {
  @Input() invoice: Invoice;

  logo = '';
  printing = false;
  saving = false;

  constructor() {
    super();

    this.logo = this.Config.LogoDark;
  }

  ngOnInit(): void {
    console.log(this.invoice)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.invoice) {
      this.invoice.inv_discount_total = this.invoice.invoice_list.reduce((a, b) => a + b.inv_list_discount, 0);

      this.stretchFull();
    }
  }

  stretchFull() {
    setTimeout(() => {
      const trHeight = document.querySelector('#tr0')?.clientHeight || 70;
      const itemsHeight = this.invoice.invoice_list.length * trHeight;
      const filled = 360 + itemsHeight;

      const el = document.querySelector('#stretch-full-td') as HTMLDivElement;
      el.style.paddingBottom = `calc(29.7cm - 3cm - ${filled}px)`;
    }, 500);
  }

  async processPrint() {
    if (this.printing) {
      return;
    }

    this.printing = true;
    const data = await htmlToImage.toPng(document.querySelector('#a4') as HTMLDivElement, {
      quality: 2,
    });
    const imgEl = new Image();
    imgEl.src = data;

    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true,
    });
    doc.addImage(imgEl, 'html', 0, 0, 0, 0);
    // doc.save(`invoice-${dayjs().format('DD_MM_YYYY')}.pdf`);
    doc.output('dataurlnewwindow');
    this.printing = false;

    // const doc = new jsPDF({
    //   orientation: 'portrait',
    //   unit: 'mm',
    //   format: 'a4',
    //   compress: true,
    //   floatPrecision: 'smart',
    // });
    // doc.html(document.querySelector('#a4') as HTMLDivElement, {
    //   callback: (doc2) => {
    //     doc2.save('new.pdf');
    //   }
    // });
  }

  async processSaveImage() {
    if (this.saving) {
      return;
    }

    this.saving = true;
    const data = await htmlToImage.toPng(document.querySelector('#a4') as HTMLDivElement)
    const a = document.createElement("a");
    a.href = data;
    a.download = `invoice_${this.invoice.agent_down_name}_${dayjs().format('DD_MM_YYYY')}.png`;
    a.click();
    this.saving = false;
  }
}
